import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import { useRef, useCallback, Fragment } from 'react';
import { BsChevronLeft, BsChevronRight, BsSearch } from 'react-icons/bs';
import { isEqual } from 'lodash';

import { useMediaQuery, MediaQuery } from '../../../hooks/useMediaQuery';
import { ProductImage } from '../../../interface/strapi';
import ResponsiveImage from '../../atoms/responsive-image/responsive-image';
import { brandColors } from '../../../constants/colors';
import * as S from './styles';

/* eslint-disable-next-line */
type HeadOnCarouselProps = {
  headOnImages: ProductImage[];
  swiperColor: string;
  handleOpenModal: () => void;
};

export function HeadOnCarousel(props: HeadOnCarouselProps) {
  const { headOnImages, swiperColor, handleOpenModal } = props;
  const sliderRef = useRef() as any;
  const isMobile = useMediaQuery(MediaQuery.SM);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const navigationColor = isEqual(swiperColor, brandColors.SUBZERO_HEX)
    ? 'text-primaryBlue'
    : 'text-primaryRed';

  const navigation = (
    <div className="block">
      <BsChevronLeft
        className={`absolute left-4 -bottom-10 text-header5 z-20 cursor-pointer ${navigationColor}`}
        onClick={handlePrev}
      />
      <BsChevronRight
        className={`absolute right-4 -bottom-10 text-header5 z-20 cursor-pointer ${navigationColor}`}
        onClick={handleNext}
      />
    </div>
  );

  function tapToMagnify() {
    if (isMobile) handleOpenModal();
    return;
  }

  const hoverMagnifyIcon = !isMobile ? (
    <div className=" flex absolute z-50 top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4 space-x-2 invisible group-hover:visible">
      <div
        className="text-white border-2 h-10 border-white rounded-full cursor-pointer hover:text-primaryBlue hover:bg-white"
        onClick={handleOpenModal}
      >
        <BsSearch className="text-header4 p-2 lg:text-header4 lg:p-2" />
      </div>
    </div>
  ) : (
    <Fragment />
  );

  const slides = headOnImages.map((headOnImage) => {
    return (
      <SwiperSlide key={headOnImage.id}>
        <S.Container isMobile={isMobile}>
          <div
            className="image-container flex flex-col items-center lg:p-12 p-0 pb-12 bg-white group"
            onClick={tapToMagnify}
          >
            <ResponsiveImage
              alt="carousel image"
              blurImageSrc="/icons/blur-placeholder.png"
              dimensions="w-full h-96 md:h-80"
              objectFit="contain"
              src={headOnImage.attributes.url}
            />
            {hoverMagnifyIcon}
          </div>
        </S.Container>
      </SwiperSlide>
    );
  });

  return (
    <S.SwiperContainer paginationColor={swiperColor}>
      {navigation}
      <Swiper
        className="mySwiper"
        loop={true}
        modules={[Autoplay, Pagination]}
        onInit={(core: SwiperCore) => {
          sliderRef.current = core.el;
        }}
        pagination={{
          clickable: true
        }}
        speed={900}
        style={{
          position: 'unset'
        }}
      >
        {slides}
      </Swiper>
    </S.SwiperContainer>
  );
}

export default HeadOnCarousel;
